'use client'
import {
  CubeTransparentIcon,
  PuzzlePieceIcon,
} from '@heroicons/react/24/outline'
import { BanknotesIcon } from '@heroicons/react/24/outline'
import { UserGroupIcon } from '@heroicons/react/20/solid'
import { HiGlobeAsiaAustralia } from 'react-icons/hi2'
import { HiRocketLaunch } from 'react-icons/hi2'
import { useEffect, useState } from 'react'

export function Numbers() {
  const [region, setRegion] = useState('')

  useEffect(() => {
    const getLocation = async () => {
      const getLocation = await fetch('/api/location')
      const loc = await getLocation.json()
      setRegion(loc.countryTimezone)
    }
    getLocation()
  }, [])

  const isAmerica = () => {
    const countryRegion = region?.toLowerCase()
    return (
      countryRegion?.includes('america') || countryRegion?.includes('caribbean')
    )
  }

  const stats = [
    // {
    //   id: 1,
    //   name: 'Direct Investment',
    //   value: isAmerica() ? '$7,500' : '£6,000',
    // },
    {
      id: 2,
      name: 'Program Value',
      value: isAmerica() ? '$60,000 ' : '£50,000',
    },
    {
      id: 3,
      name: 'Service Credits',
      value: isAmerica() ? '$155,000' : '£135,000',
    },
    // {
    //   id: 4,
    //   name: 'Professional Services',
    //   value: isAmerica() ? '$10,000' : '£10,000',
    // },
    { id: 4, name: 'Development Support', value: '100 Hours' },
  ]

  const stats2 = [
    {
      id: 1,
      name: `60% Chance to Raise ${isAmerica() ? '$200,000' : '£200,000'} `,
      value: <BanknotesIcon className="h-12 w-12 mx-auto pb-1" />,
    },
    {
      id: 2,
      name: 'Access to 110 Mentors',
      value: <PuzzlePieceIcon className="h-12 w-12 mx-auto pb-1" />,
    },
    { id: 3, name: 'Design Support', value: '30 Hours' },
  ]

  const ask = [
    { id: 1, name: 'Equity', value: '6%' },
    {
      id: 2,
      name: 'High Motivation',
      value: <HiRocketLaunch className="h-12 w-12 mx-auto pb-1" />,
    },
    {
      id: 3,
      name: 'Strong Founder Team',
      value: <UserGroupIcon className="h-12 w-12 mx-auto pb-1" />,
    },
    {
      id: 4,
      name: 'An AI Solution',
      value: <CubeTransparentIcon className="h-12 w-12 mx-auto pb-1" />,
    },
  ]
  return (
    <div>
      <div className="bg-gradient-to-r from-black to-black py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl lg:max-w-none">
            <div className="text-center">
              <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
                Our Offer
              </h2>
              <p className="mt-4 text-lg leading-8 text-gray-200">
                We believe in transparency to create valuable companies.
              </p>
            </div>
            <dl
              className="mt-16 grid grid-cols-1 gap-0.5 overflow-hidden rounded-t-2xl text-center sm:grid-cols-2 lg:grid-cols-3
            
            landscape:grid-cols-3 portrait:grid-cols-1 lg:landscape:grid-cols-3
            "
            >
              {stats.map((stat) => (
                <div key={stat.id} className="flex flex-col bg-white/5 p-8">
                  <dt className="text-sm font-semibold leading-6 text-orange-200">
                    {stat.name}
                  </dt>
                  <dd className="order-first text-3xl font-semibold tracking-tight text-white">
                    {stat.value}
                  </dd>
                </div>
              ))}
            </dl>
            <dl className="mt-0.5 grid grid-cols-1 gap-0.5 overflow-hidden rounded-b-2xl text-center sm:grid-cols-2 lg:grid-cols-3 landscape:grid-cols-3 portrait:grid-cols-1 lg:landscape:grid-cols-3">
              {stats2.map((stat) => (
                <div key={stat.id} className="flex flex-col bg-white/5 p-8">
                  <dt className="text-sm font-semibold leading-6 text-orange-200">
                    {stat.name}
                  </dt>
                  <dd className="order-first text-3xl font-semibold tracking-tight text-white">
                    {stat.value}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
        <div className="mx-auto max-w-7xl px-6 lg:px-8 mt-20">
          <div className="mx-auto max-w-2xl lg:max-w-none">
            <div className="text-center">
              <p className="mt-4 text-lg leading-8 text-gray-200">
                Our ask to turn your idea into an amazing company.
              </p>
            </div>
            <dl className="mt-16 grid grid-cols-1 gap-0.5 overflow-hidden rounded-2xl text-center sm:grid-cols-2 lg:grid-cols-4">
              {ask.map((stat) => (
                <div key={stat.id} className="flex flex-col bg-white/5 p-8">
                  <dt className="text-sm font-semibold leading-6 text-orange-200">
                    {stat.name}
                  </dt>
                  <dd className="order-first text-3xl font-semibold tracking-tight text-white">
                    {stat.value}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </div>
  )
}
